<template>
<div>
  <v-app-bar dark absolute app flat color="#367FBF" height="40" style="width: auto; margin-left:100">
    <v-btn fab text left x-small v-if="!drawer" v-tippy title="Mostrar Barra Lateral" @click="setDrawer(!drawer)">
      <v-icon small>mdi-arrow-expand-right</v-icon>
    </v-btn>
    <v-btn color="primary" fab dark x-small v-if="tipo_usuario == 1 && empresa !='' && licencia == ''" v-tippy title="Regresar a Administrar el Sistema" @click="regresar_sistema()">
      <v-icon medium>mdi-arrow-left-bold-box</v-icon>
    </v-btn>
    <v-btn color="primary" fab dark x-small v-if="(tipo_usuario == 2 || tipo_usuario == 1) && licencia != ''" v-tippy title="Regresar a Administrar la Empresa" @click="regresar_empresa()">
      <v-icon medium>mdi-arrow-left-bold-box</v-icon>
    </v-btn>
    <v-icon v-if="tipo_usuario == 1 && empresa =='' && licencia == ''" medium>mdi-tools</v-icon>
    &nbsp;&nbsp;
    <h5 style="margin-top:8px;"><b>{{titulo}}</b></h5>

    <v-spacer />
    <div style="margin-right: 20px">
      <div v-if="saldo >= 0">
        Crédito disponible: {{saldo}}
      </div>
      <div v-else>
        Saldo Pendiente: {{saldo * -1}}
      </div>
    </div>

    {{nombre}}

    <!-- Avatar Usuarios -->

    <v-menu text nav bottom left min-width="200" offset-y origin="top right" transition="scale-transition">
      <template v-slot:activator="{ attrs, on }">
        <v-btn min-width="0" icon text v-bind="attrs" v-on="on">
          <v-avatar size="32px" :key="avatar">
            <v-icon medium>person</v-icon>
          </v-avatar>
        </v-btn>
      </template>

      <v-list :tile="false" text nav>
        <template>
          <app-bar-item to="/usuarios/change">
            <v-icon>mdi-circle-small</v-icon>Cambiar Contraseña
          </app-bar-item>
          <v-divider />
          <app-bar-item @click.native="logout();">
            <v-icon>mdi-circle-small</v-icon>Cerrar Sesión
          </app-bar-item>
        </template>
      </v-list>
    </v-menu>

    <v-tooltip bottom>
      <template v-slot:activator="{ attrs, on }">
        <v-btn v-bind="attrs" fab small text v-on="on" icon @click="handleFullScreen()">
          <v-icon>fullscreen</v-icon>
        </v-btn>
      </template>
      <span>Mostrar en pantalla completa</span>
    </v-tooltip>
  </v-app-bar>
  <!-- <v-idle
                @idle="logout"
                :wait="60"
                :duration="600"/> -->
</div>
</template>

<script>
// Components
import {
  VHover,
  VListItem
} from "vuetify/lib";
import Vue from "vue";
// Utilities
import {
  mapState,
  mapMutations
} from "vuex";

import Util from "@/util";
import axios from "axios";
import resize from "vue-resize-directive";

export default {
  name: "DashboardCoreAppBar",

  directives: {
    resize
  },
  created() {
    this.verifica_sesion();
    this.uuid = this.$crypto.decrypted(this.$local_storage.get(this.$crypto.SHA256("uuid_usuario")));
    //this.intervalID = window.setInterval(() => this.$funciones.update_last_action(this.db, this.uuid), 1000 * 60 * 10);
    // this.saldo = this.$local_storage.get("saldo");
   // this.$local_storage.set("pagos","[]");

  },
  components: {

    AppBarItem: {
      render(h) {
        return h(VHover, {
          scopedSlots: {
            default: ({
              hover
            }) => {
              return h(
                VListItem, {
                  attrs: this.$attrs,
                  class: {
                    "black--text": !hover,
                    "white--text secondary elevation-12": hover
                  },
                  props: {
                    activeClass: "",
                    dark: hover,
                    link: true,
                    ...this.$attrs
                  }
                },
                this.$slots.default
              );
            }
          }
        });
      }
    }
  },

  props: {
    value: {
      type: Boolean,
      default: false
    }
  },

  data: () => ({
    fab: false,
    show_loading: false,
    show: true,
    rfc: "",
    razon: "",
    id_cliente: 0,
    minifiedLeft: false,
    hiddenLeft: false,
    avatar: "undefined",
    fullWidth: document.documentElement.clientWidth,
    // saldo: 0

  }),

  computed: {
    ...mapState(["drawer"]),
    toolbarColor() {
      return this.$vuetify.options.extra.mainNav;
    },
    saldo() {
      let saldo = this.$local_storage.get("saldo");
      if (saldo)
        return saldo;
      else
        return "";
    },
    empresa() {
      let empresa = this.$crypto.decrypted(this.$local_storage.get(this.$crypto.SHA256("nombre_empresa")));
      if (empresa)
        return empresa;
      else
        return "";
    },
    licencia() {
      let l = this.$crypto.decrypted(this.$local_storage.get(this.$crypto.SHA256("nombre_licencia")));
      if (l.length > 0)
        return l;
      else
        return "";
    },
    tipo_usuario() {
      return this.$crypto.decrypted(this.$local_storage.get(this.$crypto.SHA256("tipo_usuario")));
    },
    titulo() {

      if (this.tipo_usuario == 1 && this.empresa == '' ) {
        return "ADMINISTRACIÓN DEL SISTEMA";
      }else
        return this.empresa;


    },
    nombre() {


      let nombre_usuario = this.$crypto.decrypted(this.$local_storage.get(this.$crypto.SHA256("nombre_usuario")));

      return nombre_usuario;

    }

  },

  methods: {
    ...mapMutations({
      setDrawer: "SET_DRAWER"
    }),

    handleFullScreen() {
      Util.toggleFullScreen();
    },
    verifica_sesion: async function() {
      var datos = {
        usuario: this.$crypto.decrypted(this.$local_storage.get(this.$crypto.SHA256('uuid_usuario'))),
        opcion: 0
      };

      await this.$axios.put(this.$hostname + "carta_porte/general/verifica_sesion/", datos).then((res) => {

          if (res.data == false) {
            this.logout();
          }

        })
        .catch((err) => {
          console.log(err);
        });
    },

    change() {
      this.$router.push("/usuarios/change");
    },
    regresar_empresa() {

      this.$local_storage.set(this.$crypto.SHA256("uuid_licencia"), "");
      this.$local_storage.set(this.$crypto.SHA256("nombre_licencia"), "");
      this.$store.state.instancia = this.$crypto.SHA256("uuid_empresa"), this.$crypto.encrypted(this.empresa);
      this.$router.push("/home");

    },
    regresar_sistema() {

      this.$local_storage.set(this.$crypto.SHA256("uuid_empresa"), "");
      this.$local_storage.set(this.$crypto.SHA256("nombre_empresa"), "");
      this.$local_storage.set(this.$crypto.SHA256("uuid_licencia"), "");
      this.$local_storage.set("saldo", 0);
      this.$store.state.instancia = "super";
      this.$router.push("/home");

    },
    logout() {
      this.$root.$dialogLoader.show("Espere un momento por favor..");
     // clearInterval(this.intervalID);
      let self = this;
      var params = {
        "uuid": this.uuid
      };

      this.$axios.post(this.$hostname + "carta_porte/general/logout/", params)
        .then(res => {
          window.localStorage.clear();
          self.$local_storage.set(self.$crypto.SHA256("uuid_usuario"), self.$crypto.encrypted(""));
          self.$local_storage.set(self.$crypto.SHA256("tipo_usuario"), 0);
          self.$user.set({
            role: 0
          });

          self.$swal({
            type: "success",
            title: "Operación exitosa!",
            text: "La sesión se cerró correctamente",
            footer: "",
            confirmButtonText: "Aceptar"
          });
        })
        .catch(err => {
          self.$swal({
            type: "error",
            title: "¡ERROR!",
            text: "OCURRIÓ UN ERROR AL CERRAR LA SESIÓN",
            footer: "",
          });
        }).then(() => {
          self.$root.$dialogLoader.hide();
        });

      // window.localStorage.clear();
      // this.$local_storage.set(this.$crypto.SHA256("uuid_usuario"), this.$crypto.encrypted(""));
      // this.$local_storage.set(this.$crypto.SHA256("tipo_usuario"), 0);
      // this.$user.set({
      //   role: 0
      // });
      //
      // this.$swal({
      //   type: "success",
      //   title: "Operación exitosa!",
      //   text: "La sesión se cerró correctamente",
      //   footer: "",
      //   confirmButtonText: "Aceptar"
      // });


    },

  },
  mounted: async function() {

    this.$root.$on("cambiaravatar", new_avatar => {
      this.avatar = new_avatar;
    });
    this.avatar = this.$local_storage.get("avatar");
  }
};
</script>

<style scoped>
.v-menu__content .v-list--nav .v-list-item {
  padding-top: 0px;
  padding-bottom: 0px;
  padding-left: 5px;
  text-decoration: none;
}

.v-sheet button.v-btn.v-size--default:not(.v-btn--icon):not(.v-btn--fab) {
  padding-left: 10px !important;
}
</style>
